import { render, staticRenderFns } from "./Pg.vue?vue&type=template&id=644fe05a"
import script from "./Pg.vue?vue&type=script&lang=js"
export * from "./Pg.vue?vue&type=script&lang=js"
import style0 from "./Pg.vue?vue&type=style&index=0&id=644fe05a&prod&lang=css"
import style1 from "./Pg.vue?vue&type=style&index=1&id=644fe05a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports